import { render, staticRenderFns } from "./details-tratativa.vue?vue&type=template&id=1595a8e2&scoped=true&"
import script from "./details-tratativa.vue?vue&type=script&lang=js&"
export * from "./details-tratativa.vue?vue&type=script&lang=js&"
import style0 from "./details-tratativa.vue?vue&type=style&index=0&id=1595a8e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1595a8e2",
  null
  
)

export default component.exports